<template>
	<!-- 业务员添加进度-->
	<section class="supply-wrap">
		<div class="modal ">
		    <div class="title">添加进度</div>
		    <ul class="list-wrap che-dan">
				<li class="follow-wrap">
					<p class="follow-detail">进度标签</p>
					<div v-for='(item,index) in followTag' :key="index" class="follow-tag" :class='item.tagFlag?"current":""' @click="selectItem(item)">{{item.name}}</div>
				</li>
				
	            <li>
	            	<textarea class="textarea" :rows="8" v-model="content" @blur="backHeight" placeholder="此处输入内容用户不可见，除非开启用户可见开关。"/>
	            </li>
	            
	            <li class="admin-img no-b">
	            	<div class="num">上传图片（{{addImages.length }}/6）</div>
	            	<imageUpload v-model="addImages" :limit="6" class="add-img"/>
	            </li>
				
				<li class="notice-wrap no-b">
					<span class="notice" @click="noticeFlag=!noticeFlag" :class='noticeFlag?"on":"off"'></span>
					<span class="notice-on" >用户可见</span>
				</li>
				
		    </ul>

		    <div class="supply-submit">
				<span class="submit" @click="submitSupplyAdd">提交</span>
			</div>
		</div>
		
		<!-- 追加成功成功弹框 -->
		<toast-modal :isToast="isToast" :ToastText="ToastText"></toast-modal>
	</section>
</template>

<script>
	import imageUpload from '@/components/ImageUpload';
	import ToastModal from '@/components/ToastModal'
	import CommonModal from '@/components/CommonModal';
	import {orderFollowRecord,getProgressTag} from '@/api/order'
    export default {
        data(){
            return{
				order_uuid:this.$route.query.order_uuid,
				follow:this.$route.query.follow,
				addImages:[],
				content:"",
				noticeFlag:false,
				followTag:[
					"电话没接，信息没回，其他方式没反应，还在努力...",
					"态度恶劣，不愿沟通，还在争取",
					"希望比较大，协商条件，咱尽快",
					"答应解决，买家方便可以操作",
					"联系不上，其他方式暂时没回应，还在想办法",
				],
				tagFlag:0,    //选中的标签
				isToast:false,
				ToastText:"添加进度成功",
				addFlag:true
            }
        },
		
		beforeCreate(){
			sessionStorage.removeItem("roleType");
		},
        
        created(){
            this.getProgressTagList()
        },
		
        methods:{
            //获取情况备注
            async getProgressTagList(){
            	const { data, status } = await getProgressTag();
            	if (status !== 200) return
            	this.followTag = data.data;
				this.followTag.forEach((item,index)=>{
					this.$set(item,"tagFlag",false)
				})
            },
            
			async submitSupplyAdd(){
				if(!this.content){
					window.toast("请输入内容","txt");
					return;
				}
				
				if(!this.addFlag) {
					window.toast("请勿重复点击","txt");
					return;
				}
				this.addFlag = false;
				setTimeout(()=>{
				    this.addFlag = true;
				},3000)
				
				let type="";
				this.noticeFlag?type=1:type=2;
				let obj={content:this.content,img:this.addImages,tag:this.followTag[this.tagFlag].name,is_admin:1,type:type};
				const { status, data } = await orderFollowRecord(this.order_uuid,obj);
				if (status !== 200) return
				this.isSupplyFollow = false;
				this.isToast = true;
				setTimeout(()=>{
					this.isToast = false
					this.$router.push({path:"./order-speed",query:{order_uuid:this.order_uuid,follow:this.follow}})
				},1500)
			},
			
			selectItem(item){
				if(!item.tagFlag){
					this.$set(item,"tagFlag",true);
					if(this.content && this.content.slice(-1)!=","){//手动输入没有输入逗号，则选择下个标签的时候前面要加上
						this.content += ","+item.name+',';
					}else{
						this.content += item.name+',';
					}
				}
				else{
					this.$set(item,"tagFlag",false);
					this.content = this.content.replace(item.name+',',"")
				}
			},
			
			backHeight(){
			    setTimeout(() => {
			        const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
			        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
			    }, 100);
			}
        },
		components:{
			imageUpload,
			CommonModal,
			ToastModal
		}
        
    };
</script>
<style lang="less" scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
	section{font-family:PingFangSC-Regular;font-weight:400;background:#FFF}
	.modal{background: #fff;margin: 0 auto;padding-bottom: 20px;}
	.title{padding: 12px 20px 0 20px;font-size:18px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);text-align: center;}
	
	/* 补充资料弹框 */
	.list-wrap{padding: 15px 15px 15px 15px;}
	.list-wrap li{margin-bottom: 10px}
	.list-wrap .no-b{margin-bottom: 0px}
	.textarea{width: 100%;height: 105px;padding: 10px;appearance: none;background:rgba(245,245,245,1);border-radius:2px;border:1px solid rgba(207,207,207,1);resize: none;outline: none;font-size:13px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(153,153,153,1);}
	.done{background: url(../../assets/images/home/pic_right2_pitchon.png) no-repeat center center;background-size:cover;}
	.undone{background: url(../../assets/images/home/pic_right2_pitchoff.png) center center no-repeat;background-size: cover}
	.num{font-size:14px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(20,20,20,1);margin-bottom: 12px}
	.supply-wrap /deep/ .modal{padding-bottom: 0;}
	.supply-submit{display: flex;align-items: center;justify-content: space-between;width: 100%;height: 49px;color: #ffffff;}
	.supply-submit .cancel{width: 50%;height:49px;line-height: 49px;font-size: 18px;color: rgba(153,153,153,1);text-align: center;border-right: 1px solid #DDDDDD}
	.supply-submit .submit{width: 50%;height:40px;line-height: 40px;font-size: 18px;font-weight: 500;text-align: center;background: #4184f4;border-radius: 0.106667rem;border: 0.026667rem solid rgba(65, 132, 244, 0.5);margin: 0 auto;}
	
	.notice-wrap{display: flex;align-items: center;font-size:13px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(174,174,174,1);}
	.notice-on{display: inline-block;margin-right: 50px}
	.notice{width: 25px;height:15px;margin-right: 12px}
	.on{background: url(../../assets/images/personal/pic_mine_on.png) no-repeat center center;background-size: 25px;}
	.off{background: url(../../assets/images/personal/pic_mine_off.png) no-repeat center center;background-size: 25px;}
	
	// .follow-wrap{padding: 0 8px 0px 20px;}
	.follow-wrap  .follow-tag{display: inline-block;padding: 4px 8px 5px 4px;margin-bottom: 5px;margin-right: 5px;;border-radius:3px;border:1px solid rgba(174,174,174,1);color:rgba(174,174,174,1);font-weight:400;font-size: 12px;}
	.follow-wrap .current{border:1px solid rgba(65,132,244,0.5);background:rgba(65,132,244,0.1);color:rgba(65,132,244,1);}
	.follow-detail{padding-bottom: 10px;font-size:14px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(20,20,20,1);}
	.follow-detail span{font-size:12px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(174,174,174,1);}
</style>
